module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage6-0c3d0acb.jpeg";